import { render, staticRenderFns } from "./CoaCategory.vue?vue&type=template&id=65341e8a&"
import script from "./CoaCategory.vue?vue&type=script&lang=js&"
export * from "./CoaCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports